export default __webpack_public_path__ + "static/media/medical_6.927ff3aa.jpg";